var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-158 -240)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#162055"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 20,
    rx: 4,
    stroke: "none",
    width: 20,
    x: 158,
    y: 240
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 19,
    rx: 3.5,
    width: 19,
    x: 158.5,
    y: 240.5
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#61b93a",
    transform: "matrix(.70710678 -.70710678 .70710678 .70710678 162.696 250.659)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 5,
    rx: 0.599,
    width: 1.198
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1.198,
    rx: 0.599,
    width: 10,
    y: 3.802
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.e5aa2106854080f0dca45e8ace67e934.svg";
export { ForwardRef as ReactComponent };